import { useTheme } from '@emotion/react';
import { Typography } from '@shipengine/giger';
import { useMedia } from '@packlink/utils';
import { useTranslation } from '@packlink/translation-provider';
import { getTransitSectionStyles, getTransitStyles, getEstimatedTimeStyles, getCaptionStyles, getOverlineStyles } from './TransitStyles.js';
import { jsx, jsxs } from '@emotion/react/jsx-runtime';

const HOURS_LIMIT = 48;
const Transit = _ref => {
  let {
    transit: {
      duration,
      guaranteed
    },
    showTags = false
  } = _ref;
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const isMobile = useMedia(`(max-width: ${theme.breakPoints.tablet}px)`);
  const transitUnit = t(`service-card.date.${duration > HOURS_LIMIT ? 'days' : 'hours'}`);
  const transitType = t(`service-card.transit.${guaranteed ? 'guaranteed' : 'estimated'}`);
  return jsx("section", {
    css: getTransitSectionStyles,
    children: jsxs("div", {
      css: getTransitStyles(showTags),
      children: [jsx(Typography, {
        variant: isMobile ? 'heading5' : 'heading2',
        css: getEstimatedTimeStyles,
        children: jsx("p", {
          children: duration > HOURS_LIMIT ? Math.round(duration / 24) : duration
        })
      }), jsx("small", {
        css: getCaptionStyles,
        children: transitUnit
      }), jsx("small", {
        css: getOverlineStyles,
        children: transitType
      })]
    })
  });
};

export { Transit };
//# sourceMappingURL=Transit.js.map
